import React from "react";

import { joinClasses } from "./ResultsPrimitives.jsx";

export const BRAND_NAME = "TransIA";

function resolveBrandAssetBase() {
  const isViteDev = typeof import.meta !== "undefined"
    && import.meta.env
    && import.meta.env.DEV;

  if (isViteDev) {
    const base = typeof import.meta.env.BASE_URL === "string" && import.meta.env.BASE_URL
      ? import.meta.env.BASE_URL
      : "/static/react/";
    return `${base}brand/`;
  }

  // Le backend FastAPI monte `frontend/public/brand` sur `/brand`.
  return "/brand/";
}

const brandAssetBase = resolveBrandAssetBase();

export const BRAND_LOGO_SRC = `${brandAssetBase}transia-wordmark-home.png`;
export const BRAND_IA_SRC = `${brandAssetBase}transia-ia.png`;

const WORDMARK_HEIGHT_CLASS = {
  sm: "h-8",
  md: "h-9",
  lg: "h-11",
  hero: "h-[clamp(6.5rem,15vw,11rem)]",
};

const WORDMARK_MAX_WIDTH_CLASS = {
  sm: "max-w-[min(100%,11.5rem)]",
  md: "max-w-[min(100%,11.5rem)]",
  lg: "max-w-[min(100%,14.5rem)]",
  hero: "max-w-[min(100%,48rem)]",
};

export default function BrandLogo({
  caption = null,
  className = "",
  imgClassName = "",
  showVersion = false,
  size = "md",
  variant = "wordmark",
  versionClassName = "",
  versionLabel = "Version 0.1 bêta",
}) {
  if (variant === "ia") {
    return (
      <img
        src={BRAND_IA_SRC}
        alt="IA"
        className={joinClasses([
          "inline-block h-[0.92em] w-auto translate-y-[0.06em] object-contain align-baseline",
          imgClassName,
          className,
        ])}
        draggable={false}
      />
    );
  }

  const logo = (
    <img
      src={BRAND_LOGO_SRC}
      alt={BRAND_NAME}
      className={joinClasses([
        "block w-auto object-contain",
        size === "hero" ? "object-center" : "object-left",
        WORDMARK_HEIGHT_CLASS[size] || WORDMARK_HEIGHT_CLASS.md,
        WORDMARK_MAX_WIDTH_CLASS[size] || WORDMARK_MAX_WIDTH_CLASS.md,
        imgClassName,
      ])}
      draggable={false}
    />
  );

  if (!showVersion && !caption) {
    return <span className={joinClasses(["inline-flex min-w-0 items-center", className])}>{logo}</span>;
  }

  return (
    <span className={joinClasses(["grid min-w-0 gap-1 leading-none", className])}>
      {logo}
      {showVersion ? (
        <span
          className={
            versionClassName
              || "inline-flex w-fit max-w-full items-center rounded-full border border-border-warning-muted bg-amber-soft px-2 py-0.5 text-[0.62rem] font-bold uppercase tracking-[0.08em] text-status-warning-ink"
          }
        >
          {versionLabel}
        </span>
      ) : null}
      {caption ? (
        <span className="text-[0.68rem] font-medium uppercase tracking-[0.14em] text-muted">
          {caption}
        </span>
      ) : null}
    </span>
  );
}
